import type { UserLocalStorage } from "@typings/entities/users";
import type { ROLES } from "@typings/entities/users/enums";
import { createContext } from "react";

type UserContextType = {
  checkSession: () => Promise<void>;
  signOut: () => Promise<void>;
  user: UserLocalStorage | null;
  saveUser: (user: UserLocalStorage | null) => Promise<void>;
  role: (typeof ROLES)[keyof typeof ROLES] | null;
  isCheckingUser: boolean;
  setCheckingUser: (isChecking: boolean) => void;
};

export const UserContext = createContext<UserContextType | undefined>(
  undefined,
);
